import React, { useContext } from "react";
import PsContext from "../../../context";
import { Card, Col, Row } from "react-bootstrap";

const HelpLineInfo = (props) => {
  const context = useContext(PsContext);
  const academicYear = context.settingValue("current_academic_year");
  const helpLineMobile = context.settingValue("admission_support_mobile");
  const helpLineEmail = context.settingValue("admission_support_email");
  const collegeTiming = context.settingValue("admission_college_timings");
  return (
    <section style={{ backgroundColor: "#0c2340" }}>
      <div className="container overflow-visible py-3">
        <div className="helpline-bar shadow-lg">
          <Row className="g-0 align-items-center justify-content-center">
            <Col
              md={4}
              sm={6}
              xs={12}
              className="helpline-item py-2 py-md-0 border-sm-0"
            >
              <div
                className="helpline-bar-icon"
                style={{
                  color: "#00ffc3",
                  background: "rgba(0, 255, 195, 0.1)",
                }}
              >
                <i className="fa-solid fa-headset"></i>
              </div>
              <div>
                <span className="helpline-text-label">Technical Help</span>
                <span className="helpline-text-value">{helpLineMobile}</span>
              </div>
            </Col>

            <Col
              md={4}
              sm={6}
              xs={12}
              className="helpline-item py-2 py-md-0 border-sm-0"
            >
              <div
                className="helpline-bar-icon"
                style={{
                  color: "#ffb900",
                  background: "rgba(255, 185, 0, 0.1)",
                }}
              >
                <i className="fa-solid fa-envelope-open-text"></i>
              </div>
              <div>
                <span className="helpline-text-label">Support Email</span>
                <span className="helpline-text-value text-break">
                  {helpLineEmail}
                </span>
              </div>
            </Col>

            <Col
              md={4}
              sm={6}
              xs={12}
              className="helpline-item border-0 py-2 py-md-0"
            >
              <div
                className="helpline-bar-icon"
                style={{
                  color: "#a0aec0",
                  background: "rgba(160, 174, 192, 0.1)",
                }}
              >
                <i className="fa-solid fa-clock"></i>
              </div>
              <div>
                <span className="helpline-text-label">Working Hours</span>
                <span className="helpline-text-value">{collegeTiming}</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default HelpLineInfo;
